<template>
  <m-toggle-group
    :type="$attrs.type ?? 'single'"
    :value="modelValue"
    @change="updateVal"
    class="p-b-1">
    <span
      v-for="button in buttons"
      :key="button.value"
      :data-testid="testIdPrefix ? `${testIdPrefix}-${button.value}` : undefined">
      <m-toggle :value="button.value">
        <span slot="leading" v-if="button.icon">
          <basic-icon>
            {{ button.icon }}
          </basic-icon>
        </span>
        {{ button.label }}
      </m-toggle>
    </span>
  </m-toggle-group>
</template>

<script>
import { propValidatorHelper } from '@satellite/plugins/util';
import { BasicIcon } from '@/components';

/**
 * Single toggle group of buttons wrapping Miranda's <m-toggle-group> component
 * @displayName Button Toggle Group
 */
export default {
  name: 'ButtonToggleGroup',
  components: { BasicIcon },
  props: {
    /**
     * @model
     */
    modelValue: {
      type: String,
      required: false,
      default: null
    },
    /**
     * Buttons to display
     * { label: string, value: string, icon?: string }
     */
    buttons: {
      type: Array,
      required: true,
      validator(value) {
        const isValid = value.every(button =>
          Object.keys(button).every(buttonKey => ['label', 'value', 'icon'].includes(buttonKey))
        );
        return propValidatorHelper({
          value,
          isValid,
          componentName: 'ButtonToggleGroup',
          propName: 'buttons',
          message: ''
        });
      }
    },
    testIdPrefix: {
      type: String,
      default: null
    }
  },
  methods: {
    updateVal(event) {
      /**
       * update:model-value event
       * @event
       * @property { string } value
       */
      this.$emit('update:model-value', event.target.value);
    }
  }
};
</script>
